module.exports = __webpack_public_path__ + "static/media/downloads@2x.e89cf01d.webm";